import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="product-import-form"
export default class extends Controller {
  static targets = ["provider", "file", "hint"]

  connect() {
    this.updateFileInput()
  }

  updateFileInput() {
    const config = this.configForProvider(this.providerTarget.value)

    this.fileTarget.value = ""
    this.fileTarget.accept = config.accept
    this.fileTarget.disabled = config.disabled
    this.hintTarget.textContent = config.hint
  }

  configForProvider(provider) {
    if (provider === "alcyon") {
      return {
        accept: ".csv,text/csv",
        disabled: false,
        hint: "Import Alcyon: fichier CSV avec 28 colonnes."
      }
    }

    if (provider === "certivet") {
      return {
        accept: ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        disabled: false,
        hint: "Import Certivet: fichier Excel .xlsx avec les colonnes GTIN, EAN, Tarif, TVA et Coef."
      }
    }

    return {
      accept: "",
      disabled: true,
      hint: "Sélectionnez d'abord un type d'importation."
    }
  }
}
